import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const ProjectSearchHeaderWrapper = styled.div`
  margin: 4px 0px 16px;
  ${responsive.MOBILE`
     margin: 0px 0px 0px;
  `}
  .header-right {
    text-align: end;
    margin-top: 16px;
    ${responsive.MOBILE`
      margin: 0px 0px 16px 0px;
     `}

    .header-right-button {
      ${responsive.MOBILE`
        width:100%;
        padding:16px 8px;
      `}
    }
  }
`;
